import { useTranslation } from 'react-i18next'

import './unexpectedErrorMask.scss'

const UnexpectedErrorMask = () => {
  const { t } = useTranslation()

  return (
    <div className="unexpected-error-mask">
      <div className="text">{t('errorHandling.unexpected_error')}</div>
    </div>
  )
}

export default UnexpectedErrorMask
